module.exports = __webpack_public_path__ + "static/media/image-saude.348aaad4.png";